export var CommonNumericConstants = {
    DefaultSessionInactivityTimeInMillis: 30 * 60 * 1000,
    MaxSessionInactivityTimeInMillis: 48 * 60 * 60 * 1000 // 48 hours
};
